import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-image-slider',
  templateUrl: './image-slider.component.html',
  styleUrls: ['./image-slider.component.css']
})
export class ImageSliderComponent {

  @Input() imagens: any[] = [];
  @Input() visible = 4
  @Output() selectCor = new EventEmitter<any>();
  itemHeight = 120

  index = 0;

  next() {
    if (this.index + this.visible < this.imagens.length) {
      this.index++;
    }
  }

  prev() {
    if (this.index > 0) {
      this.index--;
    }
  }

  get visibleImages() {
    return this.imagens.slice(this.index, this.index + this.visible);
  }

  selecionar(img: any) {
    this.selectCor.emit(img);
  }
}